import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Box, Fab } from "@mui/material";
import Link from "@mui/material/Link";

import { siteName } from "@/constants/config";
import usePlatform from "@/hooks/usePlatform";

export function FeedbackBar() {
  const { isMobile } = usePlatform();

  return (
    <Box
      role="presentation"
      component={Link}
      href="/contact"
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        position: "fixed",
        ...(isMobile ? { bottom: 15, right: 15 } : { bottom: 110, right: 15 }),
      }}
    >
      <Fab size="small" color="primary" aria-label="scroll back to top">
        <MailOutlineIcon />
      </Fab>
    </Box>
  );
}
